import { render, staticRenderFns } from "./parainputevents.vue?vue&type=template&id=48d3702e&scoped=true"
import script from "./parainputevents.vue?vue&type=script&lang=js"
export * from "./parainputevents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d3702e",
  null
  
)

export default component.exports